<template>
    <m-pageframe
      title="Connect Shopify"
      ref="pageframe"
      :sign_in_as_route="sign_in_as_route"
    >
        <v-container class="pa-4 pa-sm-6">
            <v-alert
                v-if="!can_authorize"
                border="left"
                colored-border
                color="primary"
                elevation="2"
                type="error"
                :max-width="$vuetify.breakpoint.smAndUp ? '920' : ''"
            >
                Only Organization Admins can connect a Shopify store
            </v-alert>

            <v-card outlined class="mb-6" :max-width="$vuetify.breakpoint.smAndUp ? '920' : ''">
                <v-card-title class="grey lighten-4">
                    <v-icon left color="primary">mdi-shopping-outline</v-icon>
                    <!-- Connect Shopify -->
                    {{ this.$rc.$state.getOrganizationLabel() }}
                </v-card-title>
                
                <v-card-text class="pt-4 text-body-1">
                    Connect RedChirp to your Shopify store:

                    <span class="font-weight-bold">{{ this.params.shop }}</span>
                </v-card-text>
                
                <v-card-actions>
                    <v-btn
                        text
                        @click="selectAccount"
                    >
                        Sign In to another Organization
                    </v-btn>

                    <v-spacer/>
                    
                    <v-btn
                        color="primary"
                        :disabled="!this.can_authorize"
                        @click="startAuthorization"
                    >
                        Connect Shopify
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-container>
    </m-pageframe>
</template>
    
    <script>
    
    export default {

        mounted () {
            this.$rc.enforceSignedIn(this.$router);
        },
    
        methods: {
            selectAccount()
            {
                this.$refs['pageframe'].$refs['dialog-sign-in-as'].showDialog();
            },

            startAuthorization()
            {
                // Need to make sure the list of integrations is current
                this.$rc.getOrganizationProfile(
                    this.$rc.getOrganizationId(),
                    (profile, pixel_code) => {
                        this.createSettingsIfNecessary(profile);
                    },
                );
            },

            createSettingsIfNecessary(profile)
            {
                // First, check if there is already settings for this Shopify shop
                let settings_id = profile.integration_crm_summaries
                    .filter(summary => summary.content_type == 'shopify')
                    .filter(summary => summary.tenant == this.params.shop)
                    .map(summary => summary.settings_id)
                    .find(settings_id => true); // getFirst || undefined
                
                // If settings exist, then skip to authorization
                if (settings_id)
                {
                    this.startAuth();
                    return;
                }

                // If not, then we need to create them
                this.$rc.rest({
                    'spinner': true,
                    'endpoint': 'PATCH: /api/v1/integrations/crm/settings',
                
                    'params' : {
                        'organization_id': this.$rc.$state.getOrganizationId(),
                        'content_type': 'shopify',
                        'settings_id': this.$rc.uuidv4(),
                        'tenant': this.params.shop,
                    },
                
                    'on_success': (data) => {
                            this.startAuth();
                        },
                
                    'on_error': 'Unable to create new integration',
                });
            },

            startAuth()
            {
                this.$rc.rest({
                    'spinner': true,
                    'endpoint': 'POST: /api/v1/integrations/oauth/complete-auth',

                    'params' : {
                            'integration_type': 'shopify',
                            'organization_id': this.$rc.$state.getOrganizationId(),
                            'employee_id': this.$rc.$state.getEmployeeId(),
                            'params': this.params,
                        },
                
                    'on_success': (data) => {
                            window.location = data.url;
                        },
                
                    'on_error': 'Unable to complete OAuth pairing.',
                });
            },

        },

        computed: {
            params() {
                return { ...this.$route.params, ...this.$route.query };
            },

            can_authorize() {
                return this.$rc.$state.isOrganizationAdmin();
            },

            sign_in_as_route() {
                return {
                    'name': 'shopify_install',
                    'params': this.params,
                };
            },
        },

    }
    </script>
    
    <style lang="scss" scoped>
    </style>
    
    
    